import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeStore {
  isDarkMode: boolean;
  toggleDarkMode: () => void;
  setDarkMode: (isDark: boolean) => void;
}

function updateDOMTheme(isDark: boolean) {
  document.documentElement.classList.toggle('dark', isDark);
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      isDarkMode: false,
      toggleDarkMode: () => {
        set((state) => {
          const next = !state.isDarkMode;
          updateDOMTheme(next);
          return { isDarkMode: next };
        });
      },
      setDarkMode: (isDark) => {
        set({ isDarkMode: isDark });
        updateDOMTheme(isDark);
      },
    }),
    {
      name: 'theme-storage',
      onRehydrateStorage: () => (state) => {
        if (!state) return;
        const raw = (state as unknown as { isDarkMode?: unknown }).isDarkMode;
        state.setDarkMode(raw === true || raw === 'true' || raw === 1);
      },
    },
  ),
);
